import { APIPaths } from "@/apis/api-config";
import BaseApi from "@/apis/base-api";

export class ImageApi extends BaseApi {
  async postImageNew(
    requestBody: APIPaths["/admin-dash/image/new"]["post"]["requestBody"]["content"]["application/json"],
  ): Promise<APIPaths["/admin-dash/image/new"]["post"]["responses"]["200"]["content"]["application/json"]> {
    return (await this.post("/admin-dash/image/new", requestBody)).data;
  }
}
